import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DropdownIcon = memo(function DropdownIcon() {
    return <FontAwesomeIcon icon={ [ 'far', 'caret-square-down' ] } />;
});

export const CheckboxIcon = memo(function CheckboxIcon({ checked }) {
    if (checked) {
        return <FontAwesomeIcon
            icon={ [ 'far', 'check-square' ] }
            size={ 'sm' }
        />;
    }

    return <FontAwesomeIcon
        icon={ [ 'far', 'square' ] }
        size={ 'sm' }
    />;
});

export const RadioButtonIcon = memo(function RadioButtonIcon({ checked }) {
    if (checked) {
        return <FontAwesomeIcon
            icon={ [ 'far', 'dot-circle' ] }
            size={ 'sm' }
        />;
    }

    return <FontAwesomeIcon
        icon={ [ 'far', 'circle' ] }
        size={ 'sm' }
    />;
});

export const ToggleIcon = memo(function ToggleIcon({ checked }) {
    if (checked) {
        return <FontAwesomeIcon icon={ [ 'fas', 'toggle-on' ] } />;
    }
    return <FontAwesomeIcon icon={ [ 'fas', 'toggle-off' ] } />;
});

export const TextIcon = memo(function TextIcon() {
    return <FontAwesomeIcon
        icon={ [ 'fa', 'align-left' ] }
        size={ 'sm' }
    />;
});

export const SortIcon = memo(function SortIcon() {
    return <FontAwesomeIcon
        icon={ [ 'fa', 'grip-horizontal' ] }
        size={ 'sm' }
    />;
});

export const DragIcon = memo(function DragIcon() {
    return <FontAwesomeIcon
        icon={ [ 'fa', 'grip-vertical' ] }
        size={ 'sm' }
    />;
});
